import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutTop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLayoutTop"><Path d="M3.5 20.5L3.5 6.5L20.5 6.5V20.5L3.5 20.5Z" stroke="currentColor"/><Path d="M3 3.5H21" stroke="currentColor"/></CentralIconBase>;
});

export default IconLayoutTop;
